import { combineReducers, configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import thunk from "redux-thunk";
import { appName } from "./constants";

import authReducer from "slices/authSlice";
import companyReducer from "slices/companySlice";
import industryReducer from "slices/industrySlice";
import courseReducer from "slices/courseSlice";
import notificationReducer from "slices/notificationSlice";
import assessmentReducer from "slices/assessmentSlice";
import certificateReducer from "slices/certificateSlice";
import paymentReducer from "slices/paymentSlice";

const persistConfig = {
  key: appName.replace(" ", "-"),
  storage,
  whitelist: ['auth'],
};

const rootReducer = combineReducers({
  auth: authReducer,
  company: companyReducer,
  industries: industryReducer,
  courses: courseReducer,
  notifications: notificationReducer,
  assessments: assessmentReducer,
  certificates: certificateReducer,
  payments: paymentReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk],
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

